export default "__VITE_ASSET__BxmEwPW9__"